// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--kBQ7i","label":"_93444fe79c--label--QAN66","content":"_93444fe79c--content--PHbeJ"};